module.exports = __webpack_public_path__ + "media/images/icon/icons8-Natural User Interface 1-1aa8684d2b6a9cd5f9e744e5af0c19e3.png";